import { Navigate, useParams } from 'react-router-dom';

/** Sends an earlier Creative Strategy URL to its new home, keeping its ids. */
export function StrategyRedirect({ to }: { to: 'library' | 'dockets' }) {
  const { docketId, clientUid, itemId } = useParams();
  const id = to === 'library' ? docketId : clientUid;
  const parts = ['/knowledge/creative-strategy', to, id, itemId].filter(Boolean) as string[];
  return <Navigate to={parts.map((p, i) => (i === 0 ? p : encodeURIComponent(p))).join('/')} replace />;
}
